import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import './registerServiceWorker';
import ElementUI from 'element-ui';
import './assets/element-variables.scss';
import firebase from 'firebase/app';

Vue.use(ElementUI);
const configFirebase = {
  apiKey: 'AIzaSyAE_lkz0jofbcDev5TrQI5FzevgWi8-VQA',
  authDomain: 'people2-admin.firebaseapp.com',
  databaseURL: 'https://people2-admin.firebaseio.com/',
  storageBucket: 'people2-admin.appspot.com',
  projectId: 'people2-admin',
  messagingSenderId: '561345191871',
};
firebase.initializeApp(configFirebase);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
